<template>
    <i class="fas fa-lock"></i>
</template>

<script>
    export default {
        name: 'NotReadyToPrepareIcon',
    }
</script>
